var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6243 8.59114V8.00397C15.6243 4.78003 13.1062 2.1665 10 2.1665C6.8938 2.1665 4.37573 4.78003 4.37573 8.00397V8.59114C4.37573 9.2958 4.17476 9.98469 3.79817 10.571L2.8753 12.0078C2.03235 13.3201 2.67587 15.1039 4.14197 15.5189C7.97728 16.6046 12.0227 16.6046 15.858 15.5189C17.3241 15.1039 17.9676 13.3201 17.1247 12.0078L16.2018 10.571C15.8252 9.98469 15.6243 9.2958 15.6243 8.59114Z",
    stroke: "#15528A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.25 16.3335C6.79586 17.79 8.26871 18.8335 10 18.8335C11.7313 18.8335 13.2041 17.79 13.75 16.3335",
    stroke: "#15528A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.236f714c4e47f5f853208ce4adbd6ebc.svg";
export { ForwardRef as ReactComponent };